import script from "./Settings.vue?vue&type=script&setup=true&lang=js"
export * from "./Settings.vue?vue&type=script&setup=true&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=308e13bc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-308e13bc"]])

export default __exports__